if (document.querySelector('.layout-dashboard')) {
  var Dialog = require('../modules/dialog');
  new Dialog();
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/dialog.initializer.js